import React, {Component} from "react";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import { ASO_ASSIGNMENT_BUCKETS } from '../servicePortal/agingBuckets.js';

const ASO_ASSIGNMENT_OPTIONS = ASO_ASSIGNMENT_BUCKETS.map(bucket => ({value: bucket, label: bucket}));

class AsoAssignmentFilter extends Component {
    state = {
        asoAssignmentValue: ASO_ASSIGNMENT_OPTIONS
    };

    resetAsoAssignmentFilter() {
        this.setState({
            asoAssignmentValue: ASO_ASSIGNMENT_OPTIONS,
        })
    }

    changeAsoAssignment(optionSelected) {
        let asoAssignmentArray = [];
        const selected = optionSelected === null ? [] : optionSelected;
        selected.map((option, i) => {
            asoAssignmentArray.push(option.value)
        });
        this.props.onSelectAsoAssignment(selected, asoAssignmentArray);
        this.setState({
            asoAssignmentValue: selected,
        });
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="aso_assignment"
                isMulti
                value={this.state.asoAssignmentValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeAsoAssignment.bind(this)}
                options={ASO_ASSIGNMENT_OPTIONS}
                placeholderButtonLabel="All"
            />
        );

    }
}
export default AsoAssignmentFilter;
